import React, { FC, useState } from 'react';
import { Accordion } from '../Accordion';
import { ProductCardProps } from './ProductCard';
import { get, isEqual, map } from 'lodash';
import { sanitizeDOM, setRelAttribute } from '@trip-ux/common';

const CoverMeViewDetails: FC<Partial<ProductCardProps>> = ({ code, details, exclusion, genericLabels, pdfLink }) => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const labels = [get(genericLabels, 'detailsLabel'), get(genericLabels, 'exclusionLabel')];
  return (
    <>
      {map(
        [details, exclusion],
        (val, index) =>
          val && (
            <Accordion
              toggleElement="div"
              key={`view-details-container-${index}`}
              headingTag="h3"
              title={labels[index]}
              className="view-details-container"
              id={`view-details-container-${index}`}
              isOpen={isEqual(openAccordion, index)}
              onClick={() => (isEqual(openAccordion, index) ? setOpenAccordion(null) : setOpenAccordion(index))}>
              <div
                key={`content-${code}-${index}`}
                id={`content-${code}-${index}`}
                className="text-break view-details"
                dangerouslySetInnerHTML={{ __html: sanitizeDOM(val) }}
                data-testid={`content-${code}-${index}`}
              />
            </Accordion>
          )
      )}
      <div
        id="view-details-footer-container"
        className="text-break view-details-footer-container"
        data-testid="view-details-footer-container">
        <div className="view-details-footer">
          <span>{get(genericLabels, 'viewDetailsFooter')}</span>
          <a
            aria-label={`${get(genericLabels, 'viewPolicy')} (${get(genericLabels, 'newTabAriaLabel')})`}
            href={`${get(pdfLink, 'cmProductPdfLink', '#')}`}
            id="view-policy"
            data-testid="view-policy"
            target="_blank"
            rel={setRelAttribute(`${get(pdfLink, 'cmProductPdfLink', '#')}`)}>
            {get(genericLabels, 'viewPolicy')}
          </a>
        </div>
      </div>
    </>
  );
};
CoverMeViewDetails.displayName = 'CoverMeViewDetails';
export default CoverMeViewDetails;
